import React from 'react';
import map from 'lodash/map';
import slice from 'lodash/slice';

import TableTitle from './TableTitle';
import { sortingDirections } from './constants';
import { assetTypes } from 'helpers/constants';
import { getValueByPath } from 'helpers/objectHelper';
import { subscriptionStatus } from '../../PowertrainTools/SubscriptionStatus/constants';
import { IconGatewayFilter } from 'svgIcons/MotionPortalIcons';

const createFilterableColumnTitle = (column, sortingColumn, sortingDirection, onHeaderCell) => {
	const handleSort = () => onHeaderCell(column).onClick();
	const handleKeyDown = (e) => {
		if (column?.isSorting && (e.key === 'Enter' || e.key === ' ')) {
			e.preventDefault();
			handleSort();
		}
	};

	const titleContent =
		<TableTitle
			title={column?.title}
			sortingDirection={sortingColumn === column?.dataIndex ? sortingDirection : null}
		/>;

	const titleElement = column?.isSorting ?
		<button
			type='button'
			className='filterable-column-title'
			onClick={handleSort}
			onKeyDown={handleKeyDown}
			style={{ cursor: 'pointer' }}
		>
			{titleContent}
		</button>
		:
		<div className='filterable-column-title' style={{ cursor: 'default' }}>
			{titleContent}
		</div>;

	return (
		<div className='filterable-column-header'>
			{titleElement}
			<div className='filterable-column-filter'>
				<input
					type='text'
					className='filter-input'
					defaultValue={column?.filterValue}
					onChange={(e) => column.onFilterChange(e.target.value)}
					onClick={(e) => e.stopPropagation()}
					placeholder='Filter'
				/>
				<IconGatewayFilter width={14} height={14} color='#696969' />
			</div>
		</div>
	);
};

export const formatColumns = (columns, sortingColumn, sortingDirection, setSortingColumn, setSortingDirection) => {
	const onHeaderCell = (column) => {
		if (!column?.isSorting) {
			return null;
		}
		return {
			onClick: () => {
				if (column?.dataIndex === sortingColumn) {
					setSortingDirection(sortingDirection === sortingDirections.ASC ? sortingDirections.DESC : sortingDirections.ASC);
				} else {
					setSortingColumn(column?.dataIndex);
					setSortingDirection(sortingDirections.ASC);
				}
			}
		};
	};

	return map(columns, (column) => {
		const hasFilter = column?.filterValue !== undefined && column?.onFilterChange;

		const titleComponent = hasFilter
			? createFilterableColumnTitle(column, sortingColumn, sortingDirection, onHeaderCell)
			: <TableTitle title={column?.title} sortingDirection={sortingColumn === column?.dataIndex ? sortingDirection : null} />;
		return {
			...column,
			onHeaderCell: column?.isSorting && !hasFilter ? () => onHeaderCell(column) : null,
			title: titleComponent,
			key: column?.dataIndex
		};
	});
};

export const sortData = (data, sortingColumn, sortingDirection) => {
	if (!sortingColumn || !data) { return data; }
	return [...data].sort((a, b) => {
		const aItem = getValueByPath(a, sortingColumn);
		const bItem = getValueByPath(b, sortingColumn);
		if (a?.typeName !== subscriptionStatus.FREE_FOR_RENEWAL) {
			a.prevType = a?.typeName;
		}
		if (b?.typeName !== subscriptionStatus.FREE_FOR_RENEWAL) {
			b.prevType = b?.typeName;
		}

		const sortingItemCellA = aItem ? (aItem?.sortingItem ?? aItem).toString() : '-';
		const sortingItemCellB = bItem ? (bItem?.sortingItem ?? bItem)?.toString() : '-';
		const res = sortingItemCellA.localeCompare(sortingItemCellB, undefined, { numeric: false });

		return sortingDirection === sortingDirections.ASC ? res : res * -1;
	});
};

export const getDataChunkForPage = (data, currentPage, pageSize) => {
	return slice(data, (currentPage - 1) * pageSize, currentPage * pageSize);
};

export const getTypeClass = (type) => {
	switch (type) {
		case assetTypes.PRIMARY:
			return 'general-table-primary';
		default:
			return '';
	}
};
